import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { CONTACT, IMAGES } from "@/lib/content";

export default function FloatingPortalButton() {
  const { t } = useSite();
  return (
    <motion.a
      href={CONTACT.portal}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="etg24-floating-btn"
      initial={{ opacity: 0, scale: 0.6, y: 40 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-ibk pl-4 pr-5 py-3 shadow-[0_10px_40px_-8px_rgba(248,132,37,0.6)]"
    >
      <span className="absolute inset-0 rounded-full bg-ibk animate-ping-slow opacity-40 -z-10" />
      <span className="grid place-items-center h-8 w-8 rounded-full bg-white/95">
        <img src={IMAGES.etg24Logo} alt="etg24" className="h-4 w-auto" />
      </span>
      <span className="flex flex-col justify-center text-left leading-none">
        <span className="block text-[9px] uppercase tracking-[0.25em] text-white/80">{t.portal.label}</span>
        <span className="block text-sm font-bold text-white">etg24 Portal</span>
      </span>
      <ArrowUpRight size={18} className="text-white transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </motion.a>
  );
}
